export enum Terminal
{
    T2 = "t2",
    T3 = "t3",
    T4 = "t4",
    T5 = "t5"
}